<template>
   <SportBetsTable></SportBetsTable>
</template>

<script>

import SportBetsTable from '@/components/user/modules/sportBetsTable';

export default {
   name: "SportBets",
   components:{
      SportBetsTable
   }
}
</script>

<style scoped>

</style>
